<template>
  <div class="header">
    <div class="left">
      <!-- <img src="@/assets/logo-1.png" alt="" /> -->
      <span>一体机订单管理后台</span>
    </div>
    <div class="right">
      <!-- <span
        @click="$router.push('/login')"
        style="margin-right: 16px; cursor: pointer"
        >{{ cname }}</span
      > -->
      <a-dropdown>
        <div class="user-box">
          <div class="icon"><a-icon type="user" /></div>
          <span>{{ accname }}</span>
          <a-icon type="down" />
        </div>
        <a-menu slot="overlay">
          <a-menu-item>
            <div class="item-user">
              <div class="icon icon-user"><a-icon type="user" /></div><span>{{accname}}</span>
            </div>
          </a-menu-item>
          <a-menu-item @click="goToAccount">
            <div class="item-user">
              <div class="icon"><a-icon type="user" /></div><span>个人信息</span>
            </div>
          </a-menu-item>
          <a-menu-item key="/login" @click="handleLogout">
            <div class="item-user">
              <div class="icon"><a-icon type="poweroff" /></div><span>退出登陆</span>
            </div>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'

export default {
  props: {
    /*
    html: {
      // required: true,
      default: ''
    }
    */
  },
  data() {
    return {
      accname: '',
    };
  },
  watch: {
    /*
    html (newValue) {
      // console.log(newValue)
      this.htmlVaule = newValue
    }
    */
  },
  computed: {
    ...mapGetters([
      'loginUser'
    ])
  },
  created() {},
  mounted() {
    this.accname = this.getAccname()
  },
  methods: {
    ...mapMutations(['SET_LOGIN_USER']),
    getAccname () {
      return this.loginUser.username || '用户'
    },
    async handleLogout () {
      this.SET_LOGIN_USER({})
      this.clearAllCookie()
      this.$router.push('/login')
    },
    clearAllCookie () {
      // eslint-disable-next-line
      const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (let i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
      }
    },
    goToAccount () {
      this.$router.push('/user')
    }
  },
  destroyed() {},
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: space-between;
  padding-left: 20px;
  height: 60px;
  line-height: 60px;
  background-color: #414042;
  color: white;
  font-size: 18px;
  .left {
    display: flex;
    align-items: center;
  }
  .right {
    margin-right: 20px;
  }
  .user-box {
    display: flex;
    align-items: center;
    cursor: pointer;
    .icon {
      margin-right: 10px;
      color: #fff;
      background-color: #999;
      width: 32px;
      text-align: center;
      border-radius: 50%;
      height: 32px;
      line-height: 32px;
    }
  }
}
.item-user {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-wrap: nowrap;
  .icon {
    margin-right: 10px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
  }
  .icon-user {
    color: #fff;
    background-color: #999;
    border-radius: 50%;
  }
}
</style>
